'use client';

import { Button, type ButtonProps } from '@common/components';
import { cn } from '@core/utils';

export const MarketButton = ({
  className,
  children,
  ref,
  ...props
}: ButtonProps & { ref?: React.Ref<HTMLButtonElement> }) => {
  return (
    <Button
      ref={ref}
      dimensions="H48"
      className={cn(
        'border-[#ff4d4d]/30 bg-[#c21511] text-Gray-white shadow-[0_0_24px_rgba(255,77,77,0.6),0_0_48px_rgba(255,77,77,0.3)]',
        'hover:bg-[#a81210] active:bg-[#8f0f0e]',
        'disabled:border-Gray-100 disabled:bg-Gray-100 disabled:text-Gray-400 disabled:shadow-none',
        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
};
